import { LoadingStageModel, ValueModel } from '@kts-front/models';
import { Nullable } from '@yandex/ymaps3-types';

import { strapiApiUrls } from 'configs/strapiApiUrl';
import { TeamModel } from 'entities/Team';
import { ITeamMember, TeamMemberServer } from 'entities/Team/types';
import { OpenStore } from 'stores/local/shared/OpenStore';
import { requestStrapi } from 'utils/requestStrapi';

export class TeamResponsibleStore {
  readonly teamResponsible = new ValueModel<Nullable<ITeamMember>>(null);
  readonly loadingStage = new LoadingStageModel();
  readonly openDrawer = new OpenStore(false);

  async load(): Promise<void> {
    this.loadingStage.loading();

    const response = await requestStrapi<TeamMemberServer>().request({
      url: strapiApiUrls.teamResponsible({
        populate: {
          contacts: {
            populate: '*',
          },
        },
      }),
    });

    if (response.isError) {
      this.loadingStage.error();

      return;
    }

    this.teamResponsible.change(TeamModel.fromJson(response.data));
    this.loadingStage.success();
  }

  destroy() {
    this.teamResponsible.reset();
    this.loadingStage.reset();
  }
}
